var fs = require('fs');
var levels = require('./levels.js');
var formatDate = require('an-format-date');

function fileRenderer(config, record) {
  var args = record.args.map(arg => (typeof arg === 'string'
    // vire les préfixes ansi, mais il ne devrait pas y en avoir…
    ? arg.replace(/\x1b\[[^m]+m/g, '').replace(/\x1b/g, '')
    : arg
  ));
  if (record.level === levels.INFO && record.verb) {
    args.unshift(record.verb);
  }
  args.unshift('<'+record.name+'>');
  args.unshift(formatDate(record.timestamp, '%d/%M %H:%m:%s'));
  config.logFile.write(args.join(' ')+'\n');
}
module.exports = {
  name: 'file',
  build: function(config) {
    if (!config || !config.target) return function () {}
    return (function(config) {
      config.logFile = fs.createWriteStream(config.target, {flags : 'a'});
      return function(record) {
        fileRenderer(config, record);
      }
    })(config);
  }
}
